import Vue from 'vue'
import VueRouter from 'vue-router'

const HomeCard = () => import('../views/Home2.vue');
const Home = () => import('../views/Home.vue');
const MainMenu = () => import('@/views/MainMenu.vue');
const EditUser = () => import('@/views/user/EditUser.vue');


// 모니터링

const Summary = () => import('@/views/base/Summary.vue');
const Barometer = () => import('@/views/base/Barometer.vue');

const Weather = () => import('@/views/base/Weather.vue');
const Watt = () => import('@/views/base/Watt.vue');

//관리일지
const Ship = () => import('@/views/trace/Ship.vue');
const Grow = () => import('@/views/trace/Grow.vue');
const Market = () => import('@/views/trace/Market.vue');
const Milk = () => import('@/views/trace/NewMilk.vue');
// const newMilk = () => import('@/views/dailyrecord/Milk.vue');

// 사용자 관련 
// 로그인 화면(회원가입,아이디찾기,비번찾기) 
const Login = () => import('@/views/user/Login.vue');
// const Login2 = () => import('@/views/user/Login3.vue');
const JoinAgree = () => import('@/views/user/JoinAgree.vue');
const JoinInfo = () => import('@/views/user/JoinInfo.vue');
const FindPassword = () => import('@/views/user/FindPassword.vue');
const FindAccount = () => import("@/views/user/FindAccount.vue");

const MyInfo = () => import('@/views/user/MyInfo.vue'); 
// const RegisterUser = () => import('@/views/user/RegisterUser.vue'); 



// 정보설정
const infoSet = () => import('@/views/info/infoSet.vue'); 

// 테스트 
const ComponentTest = () => import('@/views/ComponentTest.vue');

// 제어

const ControlMonitoring = () => import('@/views/control/ControlMonitoring.vue');
const ControlSetting = () => import('@/views/control/ControlSetting.vue');
const ControlTable = () => import('@/views/control/ControlTable.vue');


// 악취
const DeodorizerMachineRoom = () => import ('@/views/deodorizer/DeodorizerMachineRoom.vue');

const DeodorizerSetMonitoring = () => import ('@/views/deodorizer/DeodorizerSetMonitoring.vue');
const DeodorizerSetting = () => import ('@/views/deodorizer/DeodorizerSetting.vue');

//esg
const Esg = () => import ('@/views/esg/Esg.vue');
const Energy = () => import ('@/views/esg/Energy.vue');
const Lowcarbon = () => import ('@/views/esg/Lowcarbon.vue');
const LowAvailable = () => import ('@/views/esg/Lowavailable.vue');
const ElectAi = () => import ('@/views/esg/ElectAi.vue');

//알림
const AlertSet = () => import ('@/views/alert/AlertSet.vue');

const NewAlertSet = () => import ('@/views/alert/NewAlertSet.vue');

const AlertPersonalSet = () => import ('@/views/alert/AlertPersonalSet.vue');
const MtraceAgree = () => import ('@/views/alert/Sms.vue');

//패키지
const rawData = () => import ('@/views/pack/rawData.vue');
const AutoWater = () => import ('@/views/pack/Autowater.vue');
const Estrusdetector = () => import ('@/views/pack/Estrusdetector.vue');
const Airconditioner = () => import ('@/views/pack/Airconditioner.vue');
const Fan = () => import ('@/views/pack/Fan2.vue');

//고객관리
const Notice = () => import ('@/views/client/notice.vue');
// const As = () => import ('@/views/client/as.vue');
const AsRegister = () => import ('@/views/client/asRegister.vue');
const AsList = () => import ('@/views/client/asList.vue');

import VueCookies from "vue-cookies";

Vue.use(VueRouter)

const routes = [
  {
    path: "/site",
    name: "MainMenu",
    component: MainMenu,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: "/",
    name: "/",
    component: Home,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  // {
  //   path: '/user/login2',
  //   name: 'Login2',
  //   component: Login2,
  //   beforeEnter: redirectTo("isLogin", "/user/login"),

  //   // beforeEnter: (to, from, next) => {
  //   //   let token = VueCookies.get("auth_token");
  //   //   // console.log("token",token);
  //   //   if (token)
  //   //     next('/')
  //   //   else
  //   //     next()
  //   // }
  // },
  {
    path: '/user/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      let token = VueCookies.get("auth_token");
      // console.log("token",token);
      if (token)
        next('/')
      else
        next()
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: redirectTo("isLogin", "/"),
  },
  {
    path: '/homecard',
    name: 'HomeCard',
    component: HomeCard,
    beforeEnter: redirectTo("isLogin", "/"),
  },

  {
    path: '/user/editUser',
    name: 'EditUser',
    component: EditUser,
    beforeEnter: redirectTo("isLogin", "/"),
  },

  // 관리일지
  {
    path: '/trace/ship',
    name: 'Ship',
    component: Ship,
    beforeEnter: redirectTo("isLogin", "/"),
  },
  {
    path: '/trace/grow',
    name: 'Grow',
    component: Grow,
    beforeEnter: redirectTo("isLogin", "/"),
  },
  {
    path: '/trace/market',
    name: 'Market',
    component: Market,
    beforeEnter: redirectTo("isLogin", "/"),
  },
  {
    path: '/trace/milk',
    name: 'NewMilk',
    component: Milk,
    beforeEnter: redirectTo("isLogin", "/"),
  },
  // {
  //   path: '/record/milk',
  //   name: 'Milk',
  //   component: Milk,
  //   beforeEnter: redirectTo("isLogin", "/"),
  // },
  // 회원가입 관련 -->
  {
    path: '/user/joinagree',
    name: 'JoinAgree',
    component: JoinAgree
  },
  {
    path: '/user/joininfo',
    name: 'JoinInfo',
    component: JoinInfo
  },
  {
    path: '/user/findid',
    name: 'FindAccount',
    component: FindAccount
  },
  {
    path: '/user/findpassword',
    name: 'FindPassword',
    component: FindPassword
  },
  
  // --> 돈방/위치 모니터 링  
  {
    path: '/summary',
    name: 'Summary',
    component: Summary,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  }, 
  {
    path: '/weather',
    name: 'Weather',
    component: Weather,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  }, 
  {
    path: '/barometer',
    name: 'Barometer',
    component: Barometer,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/watt',
    name: 'Watt',
    component: Watt,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  }, 
  // 기본 정보 (사용자,농장/사업장,거래처 등) -->
  {
    path: '/user/myinfo',
    name: 'MyInfo',
    component: MyInfo
  },
  // {
  //   path: '/user/registeruser',
  //   name: 'RegisterUser',
  //   component: RegisterUser,
  //   beforeEnter: redirectTo("isLogin", "/user/login"),
  // },

  {
    path: '/infoSet',
    name: 'infoSet',
    component: infoSet,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  
  // --> 제어
  {
    path: '/controlTable',
    name: 'ControlTable',
    component: ControlTable,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/controlMonitroing',
    name: 'ControlMonitoring',
    component: ControlMonitoring,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/controlSet',
    name: 'ControlSetting',
    component: ControlSetting,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  // --> 악취

  {
    path: '/deodorizerMonitoring',
    name: 'DeodorizerMachineRoom',
    component: DeodorizerMachineRoom,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/deodorizerSetMonitoring',
    name: 'DeodorizerSetMonitoring',
    component: DeodorizerSetMonitoring,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/deodorizersetting',
    name: 'DeodorizerSetting',
    component: DeodorizerSetting,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  // --> esg
  {
    path: '/esg/esgMonitor',
    name: 'Esg',
    component: Esg,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/esg/energy',
    name: 'Energy',
    component: Energy,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/esg/carbonaid',
    name: 'LowAvailable',
    component: LowAvailable,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/esg/lowcarbon',
    name: 'Lowcarbon',
    component: Lowcarbon,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/esg/power-forecast',
    name: 'ElectAi',
    component: ElectAi,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  // --> alert
  {
    path: '/alert/AlertSet',
    name: 'AlertSet',
    component: AlertSet,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/alert/AlertSetting',
    name: 'NewAlertSet',
    component: NewAlertSet,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/alert/AlertPersonalSet',
    name: 'AlertPersonalSet',
    component: AlertPersonalSet,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/alert/Sms',
    name: 'MtraceAgree',
    component: MtraceAgree,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  //패키지
  {
    path: '/package/RawData/:typeCode',
    name: 'rawData',
    component: rawData,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/package/AutoWater',
    name: 'Autowater',
    component: AutoWater,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/package/Estrusdetector',
    name: 'Estrusdetector',
    component: Estrusdetector,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/package/Airconditioner',
    name: 'Airconditioner',
    component: Airconditioner,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/package/Fan',
    name: 'Fan',
    component: Fan,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  // 고객관리
  {
    path: '/client/notice',
    name: 'Notice',
    component: Notice,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  // {
  //   path: '/client/as',
  //   name: 'As',
  //   component: As,
  //   beforeEnter: redirectTo("isLogin", "/user/login"),
  // },
  {
    path: '/client/asregister',
    name: 'AsRegister',
    component: AsRegister,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  {
    path: '/client/aslist',
    name: 'AsList',
    component: AsList,
    beforeEnter: redirectTo("isLogin", "/user/login"),
  },
  // --> SYSTEM , TEST 등
  {
    path: '/comp_test',
    name: 'ComponentTest',
    component: ComponentTest
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  changeBgColor(to.path);
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({ path: to.path, query: from.query });
  } else {
    next();
  }
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

function changeBgColor(path) {
  switch (path) {
    case "/":
    case "/findAccount":
    case "/config":
      document.body.style.background = "white";
      // document.body.style.background = "black";
      break;
    case "/login":
      document.body.style.background = "#191a88";
      break;
    default:
      document.body.style.background = "#f8f8f8";
      break;
  }
}

function redirectTo(getterName, redirectPath) {
  return function(to, from, next) {
    // console.log(
    //   "nevigation guard 검증 : getterName : " +
    //     getterName +
    //     ", redirectPath : " +
    //     redirectPath
    // );
    // if (store.getters[getterName]) {
    //   return next();

    let token = VueCookies.get("auth_token");
    // console.log("router -------  auth token")
    // console.log(token)
    if (token) {
      return next()

    } else {
      const redirect = { path: redirectPath };
      if (hasQueryParams(to)) {
        redirect.query = to.query;
      }
      changeBgColor(redirectPath);
      return next(redirect);
    }
  };
}

export default router
